// Staff copy for the Connections group in the new design (admin/Directory.tsx,
// Webhooks.tsx, Deliveries.tsx, Connectors.tsx, ScreenApps.tsx): the short labels,
// states and toasts the rows and drawers need, in the three languages a branch in
// Azerbaijan works in. Mail and the directory's owner parts stay English (Ruling 8)
// and have no phrases here.
// Native review pending (az, ru): the Azerbaijani and Russian here are a first
// draft. Change a phrase in all three languages at once, never in one.
import type { Phrase } from '../staffText'

export const connect = {
  // Settings frame, Oct 2026 (group B): page lines and card words. English only.
  'connect.line.notifications': { en: 'Texts customers get about their ticket.', az: '', ru: '' },
  'connect.line.deliveries': { en: 'What was sent, and whether it arrived.', az: '', ru: '' },
  'connect.line.webhooks': { en: 'Tell your own systems what happens at branches.', az: '', ru: '' },
  'connect.line.dataFeed': { en: 'A read-only login for your BI tools.', az: '', ru: '' },
  'connect.line.connectors': { en: 'Addresses your screen apps may call.', az: '', ru: '' },
  'connect.line.bookingKeys': { en: 'Keys your website and call centre book with.', az: '', ru: '' },
  'connect.webhooks.list': { en: 'Endpoints', az: '', ru: '' },
  'connect.keys.list': { en: 'Keys', az: '', ru: '' },
  'connect.log.list': { en: 'Messages', az: '', ru: '' },
  'connect.log.count': { en: '{n} message|{n} messages', az: '', ru: '' },
  'connect.log.readAt': { en: 'Read {time}', az: '', ru: '' },
  'connect.feed.login': { en: 'Database login', az: '', ru: '' },
  'connect.feed.connection': { en: 'Connection', az: '', ru: '' },
  'connect.feed.connectionLine': { en: 'What your BI tool needs.', az: '', ru: '' },
  'connect.feed.passwordLine': { en: 'The old one stops working.', az: '', ru: '' },
  'connect.feed.filesLine': { en: 'Files, read with the feed key.', az: '', ru: '' },
  'connect.feed.address': { en: 'Address', az: '', ru: '' },
  'connect.sms.onOf': { en: '{n} of {of} on', az: '', ru: '' },
  'connect.sms.col.text': { en: 'Text', az: '', ru: '' },
  'connect.sms.col.length': { en: 'Length', az: '', ru: '' },

  // shared
  'connect.edit': { en: 'Edit', az: 'Dəyiş', ru: 'Изменить' },
  'connect.keep': { en: 'Keep', az: 'Saxla', ru: 'Оставить' },
  'connect.replace': { en: 'Replace', az: 'Əvəz et', ru: 'Заменить' },
  'connect.clear': { en: 'Clear', az: 'Sil', ru: 'Удалить' },
  'connect.open': { en: 'Open', az: 'Aç', ru: 'Открыть' },
  'connect.on': { en: 'On', az: 'Aktiv', ru: 'Включён' },
  'connect.off': { en: 'Off', az: 'Söndürülüb', ru: 'Выключен' },
  'connect.none': { en: 'None', az: 'Yoxdur', ru: 'Нет' },
  'connect.unencrypted': { en: 'Unencrypted', az: 'Şifrəsiz', ru: 'Без шифрования' },
  'connect.saved': { en: 'Saved', az: 'Yadda saxlanıldı', ru: 'Сохранено' },
  'connect.deleted': { en: 'Deleted', az: 'Silindi', ru: 'Удалено' },
  'connect.secret': { en: 'Secret', az: 'Gizli açar', ru: 'Секрет' },
  'connect.newSecret': { en: 'New secret', az: 'Yeni gizli açar', ru: 'Новый секрет' },
  'connect.secretSet': { en: 'Secret set', az: 'Gizli açar var', ru: 'Секрет задан' },

  // Redesign, Oct 2026: English only.
  'connect.show': { en: 'Show', az: '', ru: '' },
  'connect.hide': { en: 'Hide', az: '', ru: '' },
  'connect.col.endpoint': { en: 'Endpoint', az: '', ru: '' },
  'connect.col.events': { en: 'Events', az: '', ru: '' },
  'connect.col.branches': { en: 'Branches', az: '', ru: '' },
  'connect.col.status': { en: 'Status', az: '', ru: '' },
  'connect.col.connector': { en: 'Connector', az: '', ru: '' },
  'connect.col.paths': { en: 'Paths', az: '', ru: '' },
  'connect.col.secret': { en: 'Secret', az: '', ru: '' },
  'connect.col.access': { en: 'Access', az: '', ru: '' },
  'connect.keyCount': { en: '{n} key|{n} keys', az: '', ru: '' },
  'connect.passed': { en: 'Passed', az: '', ru: '' },
  'connect.needsWork': { en: 'Needs attention', az: '', ru: '' },
  'connect.addressOnly': { en: 'Address only', az: '', ru: '' },
  'connect.bookingOff': { en: 'Online booking is off. Turn it on in Settings › General.', az: '', ru: '' },

  // Sign-in directory
  'connect.dirOn': { en: 'Directory sign-in on', az: 'Kataloqla giriş aktivdir', ru: 'Вход через каталог включён' },
  'connect.dirOff': { en: 'Directory sign-in off', az: 'Kataloqla giriş söndürülüb', ru: 'Вход через каталог выключен' },
  'connect.dirNone': { en: 'Not set up', az: 'Qurulmayıb', ru: 'Не настроено' },
  'connect.setUp': { en: 'Set up', az: 'Qur', ru: 'Настроить' },
  'connect.ownerOnly': { en: 'View only.', az: 'Yalnız quraşdırmanın sahibi.', ru: 'Только владелец установки.' },
  'connect.ownAccount': { en: 'Own account', az: 'Öz hesabı', ru: 'Своя учётная запись' },
  'connect.passwordMissing': { en: 'password missing', az: 'şifrə yoxdur', ru: 'нет пароля' },
  'connect.firstSignIn': { en: 'First sign-in', az: 'İlk giriş', ru: 'Первый вход' },
  'connect.createsAccount': { en: 'Creates account', az: 'Hesab yaradır', ru: 'Создаёт учётную запись' },
  'connect.existingOnly': { en: 'Existing accounts only', az: 'Yalnız mövcud hesablar', ru: 'Только существующие' },
  'connect.directoryDown': { en: 'Directory down', az: 'Kataloq əlçatmazdırsa', ru: 'Каталог недоступен' },
  'connect.graceHours': { en: 'Last password works {n} h', az: 'Son şifrə {n} saat işləyir', ru: 'Последний пароль действует {n} ч' },
  'connect.nobodySignsIn': { en: 'Nobody can sign in', az: 'Heç kim daxil ola bilməz', ru: 'Никто не может войти' },
  'connect.moreAddresses': { en: '+{n} more', az: '', ru: '' },
  'connect.leaversCheck': { en: 'Leavers check', az: '', ru: '' },
  'connect.everyMinutes': { en: 'Every {n} min', az: '', ru: '' },
  'connect.tries': { en: 'Tries', az: '', ru: '' },
  'connect.connectionSaved': { en: 'Directory connection saved', az: 'Kataloq bağlantısı saxlanıldı', ru: 'Подключение сохранено' },
  'connect.groups': { en: 'Groups', az: 'Qruplar', ru: 'Группы' },
  'connect.noGroups': { en: 'No groups yet, so nobody can sign in.', az: 'Hələ qrup yoxdur, ona görə heç kim daxil ola bilməz.', ru: 'Групп пока нет, поэтому никто не может войти.' },
  'connect.noRoleGroups': { en: 'None: nobody can sign in.', az: 'Yoxdur: heç kim daxil ola bilməz.', ru: 'Нет: никто не может войти.' },
  'connect.branchGone': { en: 'A removed branch', az: 'Silinmiş filial', ru: 'Удалённое отделение' },
  'connect.roleGone': { en: 'A removed role', az: 'Silinmiş rol', ru: 'Удалённая роль' },
  'connect.newGroup': { en: 'New group', az: 'Yeni qrup', ru: 'Новая группа' },
  'connect.directoryGroup': { en: 'Directory group', az: 'Kataloq qrupu', ru: 'Группа каталога' },
  'connect.shownAs': { en: 'Shown as', az: 'Göstərilən ad', ru: 'Показывается как' },
  'connect.groupClash': { en: 'This group already gives that. Edit that row.', az: 'Bu qrup artıq bunu verir. Həmin sətri dəyişin.', ru: 'Эта группа уже это даёт. Измените ту строку.' },
  'connect.removeGroup': { en: 'Remove group', az: 'Qrupu sil', ru: 'Удалить группу' },
  'connect.removeAsk': { en: 'Remove this group?', az: 'Bu qrup silinsin?', ru: 'Удалить эту группу?' },
  'connect.groupSaved': { en: 'Group saved', az: 'Qrup saxlanıldı', ru: 'Группа сохранена' },
  'connect.groupRemoved': { en: 'Group removed', az: 'Qrup silindi', ru: 'Группа удалена' },

  // Webhooks
  'connect.endpointCount': {
    en: '{n} endpoint, {on} on|{n} endpoints, {on} on',
    az: '{n} ünvan, {on} aktiv',
    ru: '{n} адрес, включено {on}|{n} адреса, включено {on}|{n} адресов, включено {on}',
  },
  'connect.eventCount': { en: '{n}/{of} events', az: '{n}/{of} hadisə', ru: 'Событий: {n}/{of}' },
  // Examples of what to type, the same in every language.
  'connect.egHookUrl': { en: 'https://crm.bank.az/qms/events', az: 'https://crm.bank.az/qms/events', ru: 'https://crm.bank.az/qms/events' },
  'connect.egConnectorUrl': { en: 'https://crm.bank.az/api', az: 'https://crm.bank.az/api', ru: 'https://crm.bank.az/api' },
  'connect.allBranches': { en: 'Every branch', az: 'Bütün filiallar', ru: 'Все отделения' },
  'connect.newEndpoint': { en: 'New endpoint', az: 'Yeni ünvan', ru: 'Новый адрес' },
  'connect.notHttps': { en: 'Not https: use only inside the bank.', az: 'https deyil: yalnız bankın daxilində istifadə edin.', ru: 'Не https: только внутри банка.' },
  'connect.sendWhen': { en: 'Send when', az: 'Nə vaxt göndərilsin', ru: 'Когда отправлять' },
  'connect.fromBranches': { en: 'From branches', az: 'Filiallardan', ru: 'Из отделений' },
  'connect.everyBranch': { en: 'None ticked: every branch, and new ones.', az: 'Heç biri seçilməyib: bütün filiallar, yeniləri də.', ru: 'Ничего не выбрано: все отделения, и новые тоже.' },
  'connect.offDrops': { en: 'Off drops events; none are sent later.', az: 'Söndürüldükdə hadisələr atılır, sonra göndərilmir.', ru: 'Если выключено, события теряются и позже не отправляются.' },
  'connect.testAndSecret': { en: 'Test and secret', az: 'Sınaq və gizli açar', ru: 'Тест и секрет' },
  'connect.test': { en: 'Test', az: 'Sınaq', ru: 'Тест' },
  'connect.usesSaved': { en: 'Uses the saved address.', az: 'Saxlanmış ünvandan istifadə edir.', ru: 'Использует сохранённый адрес.' },
  'connect.secretHidden': { en: 'Shown only when made.', az: 'Yalnız yaradılanda göstərilir.', ru: 'Показывается только при создании.' },
  'connect.newSecretAsk': { en: 'Replace the secret? The old one stops working now.', az: 'Gizli açar əvəz edilsin? Köhnəsi dərhal işləməyəcək.', ru: 'Заменить секрет? Старый сразу перестанет работать.' },
  'connect.deleteHookAsk': { en: 'Drop waiting messages?', az: 'Gözləyən mesajlar silinsin?', ru: 'Удалить ожидающие сообщения?' },
  'connect.secretFor': { en: 'Copy the secret for {name} now.', az: '{name} üçün gizli açarı indi köçürün.', ru: 'Скопируйте секрет для «{name}» сейчас.' },
  'connect.secretOnce': { en: 'Shown only once.', az: 'Yalnız bir dəfə göstərilir.', ru: 'Показывается один раз.' },
  'connect.copySecret': { en: 'Copy secret', az: 'Gizli açarı köçür', ru: 'Скопировать секрет' },
  'connect.secretCopied': { en: 'Secret copied', az: 'Gizli açar köçürüldü', ru: 'Секрет скопирован' },

  // Delivery log
  'connect.all': { en: 'All', az: 'Hamısı', ru: 'Все' },
  'connect.any': { en: 'Any', az: 'İstənilən', ru: 'Любое' },
  'connect.message': { en: 'Message', az: 'Mesaj', ru: 'Сообщение' },
  'connect.today': { en: 'Today', az: 'Bu gün', ru: 'Сегодня' },
  'connect.yesterday': { en: 'Yesterday', az: 'Dünən', ru: 'Вчера' },
  'connect.deliveredAt': { en: 'Delivered {time}', az: 'Çatdırıldı: {time}', ru: 'Доставлено {time}' },
  'connect.nextTry': { en: 'Next try at {time}', az: 'Növbəti cəhd {time}', ru: 'Следующая попытка в {time}' },
  'connect.attempts': {
    en: '{n} attempt|{n} attempts',
    az: '{n} cəhd',
    ru: '{n} попытка|{n} попытки|{n} попыток',
  },
  'connect.failedN': { en: '{n} failed.', az: '{n} uğursuz.', ru: 'Не доставлено: {n}.' },
  'connect.canResend': {
    en: '{n} can be sent again.',
    az: '{n} yenidən göndərilə bilər.',
    ru: 'Можно отправить снова: {n}.',
  },
  'connect.noneResend': { en: 'None can be sent again.', az: 'Heç biri yenidən göndərilə bilməz.', ru: 'Ни одно нельзя отправить снова.' },
  'connect.sendAllAgain': { en: 'Send {n} again', az: '{n} mesajı yenidən göndər', ru: 'Отправить снова ({n})' },
  'connect.sendingAgain': { en: 'Sending again', az: 'Yenidən göndərilir', ru: 'Отправляется снова' },
  'connect.sendingN': { en: 'Sending {n} again', az: '{n} mesaj yenidən göndərilir', ru: 'Снова отправляется: {n}' },

  // Connectors
  'connect.connectorCount': {
    en: '{n} connector|{n} connectors',
    az: '{n} konnektor',
    ru: '{n} коннектор|{n} коннектора|{n} коннекторов',
  },
  'connect.pathCount': {
    en: '{n} path|{n} paths',
    az: '{n} yol',
    ru: '{n} путь|{n} пути|{n} путей',
  },
  'connect.addConnector': { en: 'Add connector', az: 'Konnektor əlavə et', ru: 'Добавить коннектор' },
  'connect.nameRule': { en: 'Lower case, digits and -, at most 40.', az: 'Kiçik hərflər, rəqəmlər və -, ən çoxu 40.', ru: 'Строчные буквы, цифры и -, не более 40.' },
  'connect.notHttpsSecret': { en: 'Not https: the secret travels unencrypted.', az: 'https deyil: gizli açar şifrəsiz gedir.', ru: 'Не https: секрет передаётся без шифрования.' },
  'connect.pathsRule': { en: 'One per line. /* allows one more part.', az: 'Hər sətirdə bir. /* bir hissə də icazə verir.', ru: 'По одному в строке. /* разрешает ещё одну часть.' },
  'connect.exposure': { en: 'Any device on the machine’s network can use it. Allow only what a kiosk needs.', az: 'Cihazın şəbəkəsindəki istənilən qurğu ondan istifadə edə bilər. Yalnız kioska lazım olana icazə verin.', ru: 'Им может воспользоваться любое устройство в той же сети. Разрешайте только нужное киоску.' },
  'connect.firstMethod': { en: 'The first is used when an app names none.', az: 'Tətbiq metod göstərməyəndə birincisi istifadə olunur.', ru: 'Если приложение не указывает метод, берётся первый.' },
  'connect.secretRule': { en: 'At least 8 characters. Never shown again.', az: 'Ən azı 8 simvol. Bir daha göstərilmir.', ru: 'Не менее 8 символов. Больше не показывается.' },
  'connect.secretNeverShown': { en: 'Never shown, here or to apps.', az: 'Nə burada, nə tətbiqlərə göstərilmir.', ru: 'Не показывается ни здесь, ни приложениям.' },
  'connect.replaceSecret': { en: 'Replace secret', az: 'Gizli açarı əvəz et', ru: 'Заменить секрет' },
  'connect.saveSecret': { en: 'Save secret', az: 'Gizli açarı saxla', ru: 'Сохранить секрет' },
  'connect.clearSecretAsk': { en: 'Call it with no secret?', az: 'Gizli açarsız çağırılsın?', ru: 'Вызывать без секрета?' },
  'connect.secretSavedShort': { en: 'Secret saved', az: 'Gizli açar saxlanıldı', ru: 'Секрет сохранён' },
  'connect.secretClearedShort': { en: 'Secret cleared', az: 'Gizli açar silindi', ru: 'Секрет удалён' },
  'connect.savedSecretCleared': { en: 'Saved; new server, secret cleared', az: 'Saxlanıldı; yeni server, açar silindi', ru: 'Сохранено; новый сервер, секрет удалён' },
  'connect.deleteConnectorAsk': { en: 'Delete with its call log?', az: 'Çağırış jurnalı ilə birlikdə silinsin?', ru: 'Удалить вместе с журналом?' },
  'connect.msShort': { en: 'ms', az: 'ms', ru: 'мс' },

  // Screen apps
  'connect.appCount': {
    en: '{n} app|{n} apps',
    az: '{n} tətbiq',
    ru: '{n} приложение|{n} приложения|{n} приложений',
  },
  'connect.uploadZip': { en: 'Upload zip', az: 'Zip yüklə', ru: 'Загрузить zip' },
  'connect.uploadRule': { en: 'A zip with manifest.json, up to 25 MB. The same id adds a version.', az: 'manifest.json olan zip, 25 MB-a qədər. Eyni id versiya əlavə edir.', ru: 'Zip с manifest.json, до 25 МБ. Тот же id добавляет версию.' },
  'connect.appUploaded': { en: 'App uploaded', az: 'Tətbiq yükləndi', ru: 'Приложение загружено' },
  'connect.versionCount': {
    en: '{n} version|{n} versions',
    az: '{n} versiya',
    ru: '{n} версия|{n} версии|{n} версий',
  },
  'connect.onMachines': {
    en: 'On {n} machine|On {n} machines',
    az: '{n} cihazda',
    ru: 'На {n} устройстве|На {n} устройствах|На {n} устройствах',
  },
  'connect.notPlaced': { en: 'Not placed', az: 'Yerləşdirilməyib', ru: 'Не размещено' },
  'connect.appId': { en: 'App id', az: 'Tətbiq id', ru: 'Id приложения' },
  'connect.kind': { en: 'Kind', az: 'Növ', ru: 'Вид' },
  'connect.machines': { en: 'Machines', az: 'Cihazlar', ru: 'Устройства' },
  'connect.versions': { en: 'Versions', az: 'Versiyalar', ru: 'Версии' },
  'connect.previewNote': { en: 'Without a machine it may not finish starting.', az: 'Cihazsız tam işə düşməyə bilər.', ru: 'Без устройства может не запуститься до конца.' },
  'connect.nowCurrent': { en: 'Version {version} now current', az: '{version} versiyası indi caridir', ru: 'Версия {version} теперь текущая' },
  'connect.retireAsk': { en: 'No longer offered for machines.', az: 'Artıq cihazlar üçün təklif olunmayacaq.', ru: 'Больше не предлагается для устройств.' },
  'connect.retireFirst': {
    en: 'Runs on {n} machine: move it off first.|Runs on {n} machines: move them off first.',
    az: '{n} cihazda işləyir: əvvəlcə oradan götürün.',
    ru: 'Работает на {n} устройстве: сначала уберите.|Работает на {n} устройствах: сначала уберите.|Работает на {n} устройствах: сначала уберите.',
  },
  'connect.appRetired': { en: 'App retired', az: 'Tətbiq istifadədən çıxarıldı', ru: 'Приложение выведено' },
} satisfies Record<`connect.${string}`, Phrase>
